<p class="result-count">
  <span class="result-count__number"> {{ watchlistItemsCount }} </span>
  <span class="result-count__description" i18n="@@featureWatchlist-counter-results">
    @if (itemCategory | itemCategoryLabel; as category) { { watchlistItemsCount, plural, =1 {
    {{ category?.resultLabels?.singular }}
    } other {
    {{ category?.resultLabels?.plural }}
    } } }
  </span>
</p>
